import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(VBtn,{staticClass:"btn-checkbox",attrs:{"x-small":"","icon":""},on:{"click":_vm._onClick}},[_c(VIcon,{attrs:{"x-small":"","color":_vm.value ? '' : 'blue'}},[_vm._v("\n      fas\n      "+_vm._s(_vm.value ? 'fa-eye-slash' : 'fa-eye')+"\n    ")])],1),(_vm.label)?_c('span',{class:'small-text ' + (_vm.hidden ? 'hidden' : '')},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }